export const INTERCOM_ACTION = {
    BOOT: 'boot',
    HIDE: 'hide',
    SHOW: 'show',
    SHOW_NEW_MESSAGE: 'showNewMessage',
    SHUTDOWN: 'shutdown',
    TRACK_EVENT: 'trackEvent',
    UPDATE: 'update'
};
